import Layout from '@/page/index/index.vue';
import Store from '@/store/';

export default [{
		path: '/wel',
		component: () =>
			Store.getters.isMacOs ? import('@/mac/index.vue') : import('@/page/index/index.vue'),
		redirect: '/wel/index',
		children: [{
				path: 'index',
				name: '首页',
				meta: {
					i18n: 'dashboard',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/wel/index.vue'),
			},
			{
				path: 'dashboard',
				name: '控制台',
				meta: {
					i18n: 'dashboard',
					menu: false,
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/wel/dashboard.vue'),
			},
		],
	},
	{
		path: '/result',
		component: Layout,
		redirect: '/wel/index',
		children: [{
			path: 'syspay/success',
			name: '支付成功',
			meta: {
				i18n: 'syspaySuccess11',
			},
			component: () => import( /* webpackChunkName: "views" */ '@/views/result/syspay/success.vue'),
		}, {
			path: 'syspay/faill',
			name: '支付失败',
			meta: {
				i18n: 'syspayFaill22',
			},
			component: () => import( /* webpackChunkName: "views" */ '@/views/result/syspay/faill.vue'),
		}, {
			path: 'userPay/success/:id',
			name: '订单支付成功',
			meta: {
				i18n: 'userPaySuccess',
			},
			component: () => import( /* webpackChunkName: "views" */ '@/views/result/userPay/success.vue'),
		}, {
			path: 'userPay/faill/:id',
			name: '订单支付失败',
			meta: {
				i18n: 'userPayFaill',
			},
			component: () => import( /* webpackChunkName: "views" */ '@/views/result/userPay/faill.vue'),
		} ],
	},


	{
		path: '/meals',
		component: Layout,
		redirect: '/meals/accountMeals',
		children: [{
			path: 'sysPay/:id',
			name: '系统充值',
			meta: {
				i18n: 'sysPay',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/meals/sysPay.vue'),
		}, {
			path: 'order/:id',
			name: '系统订单',
			meta: {
				i18n: 'order',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/meals/order.vue'),
		}, ],
	},

	{
		path: '/qrcode',
		component: Layout,
		redirect: '/qrcode/qrApply',
		children: [{
			path: 'codeDetail/:id',
			name: '码详情',
			meta: {
				i18n: 'codeDetail',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/qrcode/codeDetail.vue'),
		}, ],
	},
	{
		path: '/productAndService',
		component: Layout,
		redirect: '/productAndService/renew',
		children: [{
			path: 'orderDetail/:id',
			name: '订单详情',
			meta: {
				i18n: 'orderDetail',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/productAndService/orderDetail.vue'),
		}, {
			path: 'carDetail/:id',
			name: '购物车详情',
			meta: {
				i18n: 'carDetail',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/productAndService/carDetail.vue'),
		}, {
			path: 'orderPay/:id',
			name: '待支付订单',
			meta: {
				i18n: 'orderPay',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/productAndService/orderPay.vue'),
		}, {
			path: 'pay',
			name: '订单付款',
			meta: {
				i18n: 'pay',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/productAndService/pay.vue'),
		}, ],
	},
	{
		path: '/article',
		component: Layout,
		children: [{
			path: 'index/:id',
			name: '文章详情',
			meta: {
				i18n: 'article',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/article/index.vue'),
		}, ],
	},
	{
		path: '/manual',
		component: Layout,
		name: '手册',
		children: [{
			path: 'index',
			name: '操作手册',
			meta: {
				i18n: 'manual',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/manual/index.vue'),
		}, ],
	},
	// {
	// 	path: '/inventory',
	// 	component: Layout,
	// 	name: '物资管理',
	// 	children: [{
	// 		path: 'suppliers',
	// 		name: '物资供应商管理',
	// 		meta: {
	// 			i18n: 'inventorySuppliers',
	// 		},
	// 		component: () =>
	// 			import( /* webpackChunkName: "views" */ '@/views/inventory/suppliers.vue'),
	// 	}, {
	// 		path: 'product',
	// 		name: '物资商品管理',
	// 		meta: {
	// 			i18n: 'inventoryProducts',
	// 		},
	// 		component: () =>
	// 			import( /* webpackChunkName: "views" */ '@/views/inventory/products.vue'),
	// 	}, {
	// 		path: 'enterHouse',
	// 		name: '物资入库管理',
	// 		meta: {
	// 			i18n: 'inventoryEnterHouse',
	// 		},
	// 		component: () =>
	// 			import( /* webpackChunkName: "views" */ '@/views/inventory/enterHouse.vue'),
	// 	}, {
	// 		path: 'outHouse',
	// 		name: '物资出库管理',
	// 		meta: {
	// 			i18n: 'inventoryOutHouse',
	// 		},
	// 		component: () =>
	// 			import( /* webpackChunkName: "views" */ '@/views/inventory/outHouse.vue'),
	// 	},{
	// 		path: 'inventory',
	// 		name: '物资库存管理',
	// 		meta: {
	// 			i18n: 'inventory',
	// 		},
	// 		component: () =>
	// 			import( /* webpackChunkName: "views" */ '@/views/inventory/inventory.vue'),
	// 	}, ],
	// },



	{
		path: '/farm',
		component: Layout,
		redirect: '/farm/orgBatch',
		children: [{
			path: 'farmMonitor/:id',
			name: '农场详情',
			meta: {
				i18n: 'farmMonitor',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/farm/farmMonitor.vue'),
		}, ],
	},
	{
		path: '/dict-horizontal',
		component: Layout,
		redirect: '/dict-horizontal/index',
		children: [{
			path: 'index',
			name: '字典管理',
			meta: {
				i18n: 'dict',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-horizontal.vue'),
		}, ],
	},
	{
		path: '/desk',
		component: Layout,
		redirect: '/desk/notice',
		children: [{
				path: 'addNotice',
				name: '新增通知',
				meta: {
					i18n: 'addNotice',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/desk/addNotice.vue'),
			},
			// {
			//   path: 'editNotice/:noticeId',
			//   name: '编辑文章',
			//   meta: {
			//     i18n: 'editNotice',
			//   },
			//   component: () => import(/* webpackChunkName: "views" */ '@/views/desk/editNotice.vue'),
			// },
		],
	},
	{
		path: '/doc',
		component: Layout,
		redirect: '/doc/docTemplate',
		children: [
			{
				path: 'component/editTemplate/:tplId',
				name: '文档模版编辑',
				meta: {
					i18n: 'doc-template-add',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/doc/component/editTemplate.vue'),
			},
			{
				path: 'component/addTemplate',
				name: '文档模版创建',
				meta: {
					i18n: 'form-doc-template-edit',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/doc/component/addTemplate.vue'),
			},
		],
	},
	{
		path: '/record',
		//component: Layout,
		redirect: '/trace/qrProduct',
		children: [
			{
				path: 'editRecordFormDesigner/:recordId',
				name: '编辑记录模版',
				meta: {
					i18n: 'edit-reord-form-designer',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/template/editRecordFormDesigner.vue'),
			},
			
		],
	},
	{
		path: '/template',
		
		redirect: '/template/tplForm',
		children: [{
				path: 'form-designer',
				name: '创建模版',
				meta: {
					i18n: 'form-designer',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/template/formDesigner.vue'),
			},
			{
				path: 'edit-form-designer/:formId',
				name: '编辑模版',
				meta: {
					i18n: 'edit-form-designer',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/template/editFormDesigner.vue'),
			},
			{
				path: 'editTemplate/:tplId',
				name: '表单预览',
				meta: {
					i18n: 'form-render',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/template/editTemplate.vue'),
			},
			{
				path: 'addTemplate',
				name: '模版添加',
				meta: {
					i18n: 'form-template1',
				},
				component: () => import( /* webpackChunkName: "views" */ '@/views/template/addTemplate.vue'),
			},
		],
	},
	{
		path: '/dict-vertical',
		component: Layout,
		redirect: '/dict-vertical/index',
		children: [{
			path: 'index',
			name: '字典管理',
			meta: {
				i18n: 'dict',
			},
			component: () =>
				import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-vertical.vue'),
		}, ],
	},
	{
		path: '/info',
		component: Layout,
		redirect: '/info/index',
		children: [{
			path: 'index',
			name: '个人信息',
			meta: {
				i18n: 'info',
			},
			component: () => import( /* webpackChunkName: "views" */ '@/views/system/userinfo.vue'),
		}, ],
	},
	{
		path: '/work/process/leave',
		component: Layout,
		redirect: '/work/process/leave/form',
		children: [{
				path: 'form/:processDefinitionId',
				name: '请假流程',
				meta: {
					i18n: 'work',
				},
				component: () =>
					import( /* webpackChunkName: "views" */ '@/views/work/process/leave/form.vue'),
			},
			{
				path: 'handle/:taskId/:processInstanceId/:businessId',
				name: '处理请假流程',
				meta: {
					i18n: 'work',
				},
				component: () =>
					import( /* webpackChunkName: "views" */ '@/views/work/process/leave/handle.vue'),
			},
			{
				path: 'detail/:processInstanceId/:businessId',
				name: '请假流程详情',
				meta: {
					i18n: 'work',
				},
				component: () =>
					import( /* webpackChunkName: "views" */ '@/views/work/process/leave/detail.vue'),
			},
		],
	},
];